import { render, staticRenderFns } from "./AppChameleon.vue?vue&type=template&id=6ddbb7e5&"
import script from "./AppChameleon.vue?vue&type=script&lang=js&"
export * from "./AppChameleon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports